import queryString from "query-string";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React, { Fragment, useEffect, useState } from "react";

import pages from "../../constants/pages";
import { useAxios } from "../../hooks";
import { colors } from "../css components/Style";
import List from "./template list component/Table";
import SortBy from "./template list component/SortBy";
import Pagination from "../../components/Pagination";
import { Loader, PageHeader } from "../../components";
import { PrimaryButton } from "../css components/Button";
import { startLoader, apiComplete } from "../../redux/slices/loaderSlice";

export default function TemplateList() {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const agentID = queryString.parse(window.location.search).agentID;
  const agentName = queryString.parse(window.location.search).agentName;

  const [page, setPage] = useState(1);

  const [agents, setAgents] = useState([]);
  const [message, setMessage] = useState("");
  const [templates, setTemplates] = useState("");
  const [currentAgent, setCurrentAgent] = useState({
    ID: agentID ?? "",
    name: agentName ?? "",
  });
  const [lastPage, setLastPage] = useState({ totalCount: 0, lastPage: false });

  const x_sso_token = sessionStorage.getItem("ida_sso_login");
  const { accessToken, activeBrand, authToken } = useSelector(
    (state) => state.memberDetails
  );
  const { siteColors } = useSelector((state) => state.renderUIDetails);

  const cpassAxios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: x_sso_token ? authToken : "Bearer " + accessToken,
  });

  useEffect(() => {
    dispatch(startLoader());

    axios({
      url: "/get/brandAgentDetails",
      method: "POST",
      data: {
        brand_id: activeBrand.ID,
      },
    }).then((response) => {
      if (response.status) {
        let channels = response.data.find(
          (channel) => channel?.channel_id === 1
        );

        if (response.data.length > 0 && channels) {
          if (!agentID) {
            setCurrentAgent({
              ID: channels["Whatsapp"][0]?.agent_id,
              name: channels["Whatsapp"][0]?.agent_name,
            });
          }
          setAgents((prev) => [
            ...prev,
            {
              label: "Select Agent",
              value: "",
              color: "#cbcbcb",
              isDisabled: true,
            },
          ]);
          for (let agent of channels["Whatsapp"]) {
            setAgents((prev) => [
              ...prev,
              {
                label: agent.agent_name,
                value: agent.agent_id,
                color: siteColors.primary,
              },
            ]);
          }
          dispatch(apiComplete());
        } else {
          setTemplates([]);
          setCurrentAgent([]);
          dispatch(apiComplete());
        }
      }
    });
    dispatch(apiComplete());
  }, [
    axios,
    cpassAxios,
    agentID,
    activeBrand.ID,
    dispatch,
    siteColors.primary,
  ]);

  useEffect(() => {
    if (currentAgent.ID) {
      dispatch(startLoader());

      cpassAxios({
        url: `/wa/template/${currentAgent.ID}?page=${page}&limit=10`,
        disableRedirect: true,
        disableError: true,
      })
        .then((response) => {
          if (response.status) {
            setTemplates(response.data);

            setLastPage({
              totalCount: response.data.total_template,
              lastPage: response.data.temp_obj?.length < 10,
            });
            dispatch(apiComplete());

            if (
              response.data?.temp_obj?.length === 0 ||
              response.data?.length === 0
            ) {
              setMessage(response.message?.displayMessage);
            }
          } else {
            setTemplates([]);
            setMessage(response?.message?.errorMessage);
            dispatch(apiComplete());
            setLastPage({
              totalCount: 0,
              lastPage: false,
            });
          }
        })
        .catch((error) => {
          setTemplates([]);

          dispatch(apiComplete());
        });
    }
  }, [cpassAxios, currentAgent.ID, page, dispatch]);

  function handlePagination(step, index) {
    setPage((prev) =>
      step === "index" ? index : prev + (step === "next" ? 1 : -1)
    );
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PageHeader
            pageName={"My Templates"}
            pageHeader="List of Templates"
            icons={[
              <SortBy
                agents={agents}
                sortBy={currentAgent.ID}
                setPage={setPage}
                setSortBy={setCurrentAgent}
              />,
              <PrimaryButton
                variant="contained"
                onClick={() =>
                  navigate(
                    pages.createTemplate.route +
                      "?agentID=" +
                      currentAgent.ID +
                      "&agentName=" +
                      currentAgent.name
                  )
                }
              >
                Create Template
              </PrimaryButton>,
            ]}
          />
        </Grid>
      </Grid>

      <Loader height="75%">
        {agents?.length > 0 && templates?.temp_obj?.length > 0 ? (
          <List currentAgent={currentAgent} templates={templates} />
        ) : (
          <Fragment>
            {message ? (
              <Typography
                style={{ textAlign: "center", color: colors.lightGreen }}
                variant="h6"
              >
                {message}
              </Typography>
            ) : (
              templates === "" && (
                <Typography
                  variant="h5"
                  style={{
                    color: colors.lightGreen,
                    textAlign: "center",
                  }}
                >
                  Loading ....
                </Typography>
              )
            )}

            {!message && !Boolean(templates?.temp_obj?.length === 0) && (
              <Typography
                variant="h5"
                style={{
                  color: colors.error,
                  textAlign: "center",
                }}
              >
                Templates not found
              </Typography>
            )}
          </Fragment>
        )}
      </Loader>

      {parseInt(lastPage.totalCount) > 0 && (
        <Grid
          style={{ marginTop: "20px" }}
          item
          container
          display={"flex"}
          justifyContent={"center"}
        >
          <Pagination
            count={Math.ceil(lastPage.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
